import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../imageWithBasePath'

const Footer = () => {
  const jadipraktisiLinks = [
    { text: 'Live Teaching', url: 'https://jadipraktisi.com/live' },
    { text: 'Video E-Course', url: 'https://jadipraktisi.com/e-course' },
    { text: 'Jadipraktisi for Corporate', url: 'https://corporate.jadipraktisi.com' },
    { text: 'Jadipraktisi on Campus', url: 'https://campus.jadipraktisi.com' },
    { text: 'Tryout CBT', url: 'https://jadipraktisi.com/ukom' },
    { text: 'Smart Pharmacy Edu', url: 'https://spe.jadipraktisi.com' },
  ];

  const moreLinks = [
    { text: 'Tentang', url: 'https://tentang.jadipraktisi.com' },
    { text: 'Blog', url: 'https://blog.jadipraktisi.com' },
    { text: 'Career', url: 'https://career.jadipraktisi.com' },
  ];

  return (
    <>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-bg">
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-01.png"
            className="footer-bg-1"
            alt=""
          />
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-02.png"
            className="footer-bg-2"
            alt=""
          />
        </div>
        <div className="footer-top">
          <div className="container">
            <div className="row row-gap-4">
              <div className="col-lg-5">
                <div className="footer-about">
                  <div className='d-flex justify-content-start mb-3'>
                    <div className="footer-logo w-100 mb-0 d-flex align-items-center">
                      <ImageWithBasePath
                        src="/assets/img/logo-color.webp"
                        width={190}
                        alt=""
                      />
                    </div>
                    <div className='ms-3 w-100 d-flex flex-column justify-content-center align-items-center'>
                      <h5 className="footer-title text-center" style={{ fontSize: '15px' }}>DIDUKUNG SERTIFIKAT</h5>
                      <ImageWithBasePath
                        src="/assets/img/skp-kemenkes.png"
                        alt=""
                        width={67}
                      />
                    </div>
                  </div>
                  <p style={{ color: '#1E344C', fontSize: '18px' }} className='fw-bold mb-1'>PT. Jadi Praktisi Indonesia</p>
                  <p style={{ color: '#1E344C', fontSize: '16px' }} className='fw-medium'>
                    Jl. Sugriwa, No. 10, Kec. Tanjung Karang Timur, Kota Bandar Lampung 35121
                  </p>

                  {/* <div className="d-flex align-items-center">
                    <Link to="#" className="me-2">
                      <ImageWithBasePath
                        src="/assets/img/icon/appstore.svg"
                        alt=""
                      />
                    </Link>
                    <Link to="#">
                      <ImageWithBasePath
                        src="/assets/img/icon/googleplay.svg"
                        alt=""
                      />
                    </Link>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-7">
                <div className="row row-gap-4">
                  <div className="col-lg-4">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">Program</h5>
                      <ul>
                        {jadipraktisiLinks.map((link, idx) => (
                          <li key={idx}>
                            <Link to={link.url}>{link.text}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">Lainnya</h5>
                      <ul>
                        {moreLinks.map((link, idx) => (
                          <li key={idx}>
                            <a href={link.url} target="_blank" rel="noopener noreferrer">
                              {link.text}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="footer-widget footer-contact">
                      <h5 className="footer-title">Ikuti Kami</h5>
                      <div className="d-flex align-items-center justify-content-start">
                        <Link
                          to="https://web.facebook.com/profile.php?id=61575052046766"
                          target="_blank"
                          className="text-primary me-3"
                          style={{ fontSize: '20px' }}
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-facebook-f" />
                        </Link>
                        <Link
                          to="https://www.youtube.com/@jadipraktisicorp"
                          target="_blank"
                          className="text-primary me-3"
                          style={{ fontSize: '20px' }}
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-youtube" />
                        </Link>
                        <Link
                          to="https://www.linkedin.com/company/jadipraktisi/"
                          target="_blank"
                          className="text-primary me-3"
                          style={{ fontSize: '20px' }}
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                        <Link
                          to="https://instagram.com/jadipraktisi"
                          target="_blank"
                          className="text-primary me-3"
                          style={{ fontSize: '20px' }}
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-instagram" />
                        </Link>
                        <Link
                          to="mailto:lifeatjadipraktisi@gmail.com "
                          target="_blank"
                          className="text-primary me-3"
                          style={{ fontSize: '20px' }}
                          rel="noopener noreferrer"
                        >
                          <i className="fa-solid fa-envelope" />
                        </Link>
                      </div>

                      <Link to={'https://linktr.ee/jadipraktisi'} className='btn btn-yellow mt-3' style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}>
                        <span className='fw-medium' style={{ fontSize: '18px', color: '#1E344C' }}>
                          Hubungi Lebih Lanjut
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row row-gap-2">
              <div className="col-md-6">
                <div className="text-center text-md-start">
                  <p className="text-white">
                    © {new Date().getFullYear()} <strong>PT. Jadi Praktisi Indonesia</strong>. All
                    rights reserved.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <p className='text-white text-center text-md-end'>#UpgradeSkillPraktisi</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* /Footer */}
    </>
  )
}

export default Footer
